module.exports = __webpack_public_path__ + "static/media/defaultAvatar.8a40644b.png";